export const invoiceType = (isExpense: boolean, totalAmountCents: number) => {
  if (isExpense) {
    return totalAmountCents > 0 ? 'debit' : 'credit'
  } else {
    return totalAmountCents > 0 ? 'credit' : 'debit'
  }
}
